import 'css-chunk:src/app/containers/Home/AdminToolsView/DeleteCreatorFromAspireForm.scss';export default {
  "form": "_form_1p9ud_2"
};